import Quill from 'quill'

const Block = Quill.import('blots/block')
const Inline = Quill.import('blots/inline')

class AccordionTitleBlock extends Block {}
AccordionTitleBlock.blotName = 'accordion-title'
AccordionTitleBlock.tagName = 'div'
AccordionTitleBlock.className = 'faq-accordion__title'

const removeClassesByPrefix = (node, prefix) => {
  Array.from(node.classList)
    .filter(className => className.startsWith(prefix))
    .forEach(className => node.classList.remove(className))
}

class FaqTableRowBlock extends Block {
  static create (value) {
    const node = super.create()
    FaqTableRowBlock.applyColumnClass(node, value && value.columns)
    FaqTableRowBlock.applyPositionClass(node, value && value.position)
    return node
  }

  static formats (domNode) {
    return {
      columns: parseInt(domNode.getAttribute('data-table-columns'), 10) || 1,
      position: domNode.getAttribute('data-table-position') || 'middle'
    }
  }

  format (name, value) {
    if (name === this.statics.blotName && value) {
      FaqTableRowBlock.applyColumnClass(this.domNode, value.columns)
      FaqTableRowBlock.applyPositionClass(this.domNode, value.position)
    } else {
      super.format(name, value)
    }
  }

  static normalizeColumns (columns) {
    const parsed = parseInt(columns, 10)
    if (Number.isNaN(parsed) || parsed < 1) return 1
    return Math.min(parsed, 6)
  }

  static applyColumnClass (node, columns) {
    const normalized = FaqTableRowBlock.normalizeColumns(columns)
    node.setAttribute('data-table-columns', normalized)
    removeClassesByPrefix(node, 'faq-table__row--cols-')
    node.classList.add(`faq-table__row--cols-${normalized}`)
  }

  static applyPositionClass (node, position) {
    const allowedPositions = ['first', 'middle', 'last', 'single']
    const normalized = allowedPositions.includes(position) ? position : 'middle'
    node.setAttribute('data-table-position', normalized)
    removeClassesByPrefix(node, 'faq-table__row--pos-')
    node.classList.add(`faq-table__row--pos-${normalized}`)
  }
}
FaqTableRowBlock.blotName = 'faq-table-row'
FaqTableRowBlock.tagName = 'div'
FaqTableRowBlock.className = 'faq-table__row'

class FaqTableCellInline extends Inline {
  static create (value) {
    const node = super.create(value)
    if (!node.classList.contains('faq-table__cell')) {
      node.classList.add('faq-table__cell')
    }
    if (value) {
      node.setAttribute('data-table-cell', value)
    }
    return node
  }

  static formats (domNode) {
    return domNode.getAttribute('data-table-cell') || true
  }

  format (name, value) {
    if (name === this.statics.blotName) {
      if (value) {
        this.domNode.setAttribute('data-table-cell', value)
      } else {
        this.domNode.removeAttribute('data-table-cell')
      }
    } else {
      super.format(name, value)
    }
  }
}
FaqTableCellInline.blotName = 'faq-table-cell'
FaqTableCellInline.tagName = 'span'
FaqTableCellInline.className = 'faq-table__cell'

class AccordionContentBlock extends Block {}
AccordionContentBlock.blotName = 'accordion-content'
AccordionContentBlock.tagName = 'div'
AccordionContentBlock.className = 'faq-accordion__content'
AccordionContentBlock.allowedChildren = Block.allowedChildren.slice()
AccordionContentBlock.allowedChildren.push(FaqTableRowBlock)

Quill.register({
  'formats/accordion-title': AccordionTitleBlock,
  'formats/accordion-content': AccordionContentBlock,
  'formats/faq-table-row': FaqTableRowBlock,
  'formats/faq-table-cell': FaqTableCellInline
}, true)
